import { render } from "./RegiserConsultant.vue?vue&type=template&id=74774704"
import script from "./RegiserConsultant.vue?vue&type=script&lang=js"
export * from "./RegiserConsultant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__